module.exports = __webpack_public_path__ + "img/single-left-arrow.55c259d3.svg";